import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

const CEPField = ({ field, useFormRef, schema, label, ...props }) => {
  const { control } = useFormRef;
  const fieldSchema = schema ? yup.reach(schema, field) : null;

  const formatCep = (value) => {
    let v = (value || '').replace(/\D/g, '');
    v = v.replace(/(\d{5})(\d)/, '$1-$2');
    v = v.replace(/(-\d{3})\d+?$/, '$1');
    return v;
  };

  return (
    <Controller
      name={field}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => (
        <TextField
          fullWidth
          inputRef={ref}
          label={fieldSchema?.spec?.label ?? label ?? 'CEP'}
          required={!!fieldSchema?.exclusiveTests?.required}
          error={!!error}
          helperText={error?.message}
          value={value ? formatCep(value) : ''}
          onChange={(e) => {
            const masked = formatCep(e.target.value);
            onChange(masked);
          }}
          onBlur={onBlur}
          InputLabelProps={{
            shrink: Boolean(value) || undefined,
            ...props.InputLabelProps,
          }}
          {...props}
        />
      )}
    />
  );
};

export default CEPField;
